import React, { useCallback, useState } from 'react';
import ModalTransition from '@atlaskit/modal-dialog/modal-transition';
import { useEffectWithoutConcurrency } from '@atlassian/jira-react-strict-mode/src/useEffectWithoutConcurrency.tsx';
import type { RouteContext } from '@atlassian/react-resource-router';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import WorkflowViewDiagramModal from '@jira/project-settings__workflow-view-diagram-modal/src/WorkflowViewDiagramModalApp.tsx';
import { LegacyPage } from '@jira/router-routes__common/src/ui/legacy-page/main.tsx';

type Props = RouteContext;

export const ProjectSettingsIssueTypesTable = (props: Props): React.JSX.Element => {
	const [selectedWorkflow, setSelectedWorkflow] = useState<string | undefined>(undefined);

	const handleOnClose = useCallback(() => {
		setSelectedWorkflow(undefined);
	}, [setSelectedWorkflow]);

	const getProjectId = () => {
		const elm = globalThis.document?.getElementById('project-config-panel-issuetypes');
		const projectId = elm?.getAttribute('data-project-id');
		return projectId !== null ? projectId : undefined;
	};

	useEffectWithoutConcurrency(() => {
		const workflowDiagramLinks = globalThis.document?.querySelectorAll(
			'#project-config-issuetypes-table .project-config-issuetype-readonly-workflow',
		);

		workflowDiagramLinks.forEach((diagramLink: Element) => {
			const workflowName = diagramLink.getAttribute('data-workflowname');
			if (workflowName) {
				diagramLink.addEventListener('click', (event: Event) => {
					event.preventDefault();
					setSelectedWorkflow(workflowName);
				});
			}
		});
	});

	return (
		<JSErrorBoundary
			id="project-settings-issue-types-error-boundary"
			packageName="jiraRouterRoutesLegacyProjectSettingsIssueTypes"
			teamName="helix"
			fallback="flag"
		>
			<LegacyPage {...props} />
			<ModalTransition>
				{selectedWorkflow && (
					<WorkflowViewDiagramModal
						projectId={getProjectId()}
						workflowIdentifier={{ workflowName: selectedWorkflow }}
						onClose={handleOnClose}
					/>
				)}
			</ModalTransition>
		</JSErrorBoundary>
	);
};
